var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-view", {
        attrs: {
          profil: _vm.profil,
          spravy: _vm.spravy,
          kravicka: _vm.kravicka,
          obchod: _vm.obchod,
          satnik: _vm.satnik,
          album: _vm.album,
          canAdopt: _vm.canAdopt
        },
        on: {
          resetProfil: _vm.clearUserData,
          updateProfil: _vm.getUserData,
          "update:profil": function($event) {
            _vm.profil = $event
          },
          "update:spravy": function($event) {
            _vm.spravy = $event
          },
          "update:kravicka": function($event) {
            _vm.kravicka = $event
          },
          "update:obchod": function($event) {
            _vm.obchod = $event
          },
          "update:satnik": function($event) {
            _vm.satnik = $event
          },
          "update:album": function($event) {
            _vm.album = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.responseText != ""
        ? _c(
            "div",
            {
              class: "alert alert-" + _vm.responseType,
              attrs: { role: "alert" }
            },
            [
              _c("span", { class: "icon-" + _vm.responseType }),
              _vm._v(_vm._s(_vm.responseText) + "\n    ")
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }